import ACTION_TYPES from '../../constants/actionTypes';
import api from '../../api';

/**
 * Get policies
 * =========================
 */

function getPoliciesRequest(opts) {
  return {
    type: ACTION_TYPES.GET_POLICIES,
    payload: opts,
  };
}

function getPoliciesSuccess(policies) {
  return {
    type: ACTION_TYPES.GET_POLICIES_SUCCESS,
    payload: policies,
  };
}

function getPoliciesFailure(error) {
  return {
    type: ACTION_TYPES.GET_POLICIES_FAILURE,
    error,
  };
}

export function getPolicies({ clientId }) {
  return (dispatch, getState) => {
    const { authToken } = getState();
    const payload = {
      authToken,
      clientId,
    };

    dispatch(getPoliciesRequest({ clientId }));
    return new Promise((resolve, reject) => {
      api
        .getPolicies(payload)
        .then((policies) => {
          dispatch(getPoliciesSuccess(policies));
          resolve(policies);
        })
        .catch((error) => {
          dispatch(getPoliciesFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Get policy
 * =========================
 */

function getPolicyRequest(policyId) {
  return {
    type: ACTION_TYPES.GET_POLICY,
    payload: {
      policyId,
    },
  };
}

function getPolicySuccess(policy) {
  return {
    type: ACTION_TYPES.GET_POLICY_SUCCESS,
    payload: policy,
  };
}

function getPolicyFailure(error) {
  return {
    type: ACTION_TYPES.GET_POLICY_FAILURE,
    error,
  };
}

export function getPolicy(policyId) {
  return (dispatch, getState) => {
    const { authToken, authType } = getState();
    const payload = {
      authToken,
      authType,
      policyId,
    };

    dispatch(getPolicyRequest(policyId));
    return new Promise((resolve, reject) => {
      api
        .getPolicy(payload)
        .then((policy) => {
          dispatch(getPolicySuccess(policy));
          resolve(policy);
        })
        .catch((error) => {
          dispatch(getPolicyFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Submit policy number
 * =========================
 */

function submitPolicyNumberRequest({ policyId, policyNumber }) {
  return {
    type: ACTION_TYPES.SUBMIT_POLICY_NUMBER,
    payload: {
      policyId,
      policyNumber,
    },
  };
}

function submitPolicyNumberSuccess(policy) {
  return {
    type: ACTION_TYPES.SUBMIT_POLICY_NUMBER_SUCCESS,
    payload: policy,
  };
}

function submitPolicyNumberFailure(error) {
  return {
    type: ACTION_TYPES.SUBMIT_POLICY_NUMBER_FAILURE,
    error,
  };
}

export function submitPolicyNumber({ policyId, policyNumber }) {
  return (dispatch, getState) => {
    const { authToken, authType } = getState();
    const payload = {
      authToken,
      authType,
      policyId,
      policyNumber,
    };

    dispatch(submitPolicyNumberRequest({ policyId, policyNumber }));
    return new Promise((resolve, reject) => {
      api
        .submitPolicyNumber(payload)
        .then((policy) => {
          dispatch(submitPolicyNumberSuccess(policy));
          resolve(policy);
        })
        .catch((error) => {
          dispatch(submitPolicyNumberFailure(error));
          reject(error);
        });
    });
  };
}
